import axios from "axios";
const { REACT_APP_GET_EDITORIAL_CONTENT_URL} = process.env;

export class EditorialContentService {

    getEditorialContent(delegationCode, demandeTypeCode, exercice) {
        return axios.get(REACT_APP_GET_EDITORIAL_CONTENT_URL + "?delegationCode=" + delegationCode + "&demandeTypeCode="+ demandeTypeCode + "&exercice=" + exercice);
    }
}
